<template>
    <div style="height: 100%;" ref="webix-container">
    </div>
</template>

<script>
import { client as http } from "@/http_client";

// let testEvents = [
//     {
//         "calendar": 1, "id": 0, "start_date": "2023-03-27 14:45:00", "end_date": "2023-03-27 16:45:00", "text": "120 min", "details": "120 min: Meet with your collaborative team.", "min": 120, "section": 1
//     },
//     {
//         "calendar": 2, "id": 1, "start_date": "2023-03-28 17:30:00", "end_date": "2023-03-28 20:00:00", "text": "150 min", "details": "150 min: Collaborating with mentor re: instructional coaching, curriculum, and conferences", "min": 150, "section": 1
//     },
//     {
//         "calendar": 3, "id": 2, "start_date": "2023-03-29 17:30:00", "end_date": "2023-03-29 20:30:00", "text": "180 min", "details": "180 min: Participate in group discussions about your study topic.", "min": 180, "section": 2
//     }
// ];

// let testSections = [
//     {
//         "id": 1, "text": "Collaborative Team", "color": "#000000"
//     },
//     {
//         "id": 2, "text": "Mentor", "color": "#ffffff"
//     },
//     {
//         "id": 3, "text": "Group Discussions", "color": "#91E4A6"
//     }
// ]

let uid = '';

class customBackend extends scheduler.services.Backend {
    events() {
        return webix.promise.resolve((() => {
            return http.get(`users/${uid}/study_log`).then(response => {
                return response.data;
            });
        })());
        // return webix.promise.resolve(testEvents);
    }

    // sections() {
    //     return webix.promise.resolve(testSections);
    // }

    // calendars() {
    //     return webix.promise.resolve([
    //         { "text": "Personal", "active": 1, "id": "1" },
    //         { "text": "Public", "active": 1, "id": "2" },
    //         { "text": "Birthdays", "active": 0, "id": "3" },
    //         { "text": "Holidays", "active": 0, "id": "4" },
    //     ]);
    // }
}

export default {
    name: "WebixStudyLog",
    props: ['userId'],
    data: function () {
        return {
        }
    },
    methods: {},
    mounted() {
        uid = this.userId;
        this.webixId = webix.ui({
            container: this.$el,
            $scope: this,
            view: "scheduler",
            mode: 'week',

            date: new Date(),
            timelineMode: 'day',
            readonly: true,

            serverUTC: false,
            calendars: false,
            override: new Map([
                [scheduler.services.Backend, customBackend],
            ]),
        });

        window.addEventListener('resize', () => {
            webix.$$(this.webixId).resize();
        });
    },
    destroyed: function () {
        webix.$$(this.webixId).destructor();
    }
}
</script>

<style scoped lang="css"></style>